
import React, { useEffect, useState } from 'react';
import styles from './greeting.module.scss';

const Greeting = () => {
    const [subtitle, setSubtitle] = useState('');

    useEffect(() => {
        const hour = new Date().getHours();

        if (hour < 12) {
            setSubtitle('Start your morning with smooth flavors.');
        } else if (hour < 18) {
            setSubtitle('Unwind this afternoon with rich aromas.');
        } else {
            setSubtitle('Let the night breathe with shisha and vibes.');
        }
    }, []);

    return (
        <section className={styles.hero}>
            <svg className={styles.smoke} aria-hidden="true">
                <filter id="smoke">
                    <feTurbulence type="fractalNoise" baseFrequency="0.008" numOctaves="3" seed="7" />
                    <feDisplacementMap in="SourceGraphic" scale="40" />
                </filter>
                <rect width="100%" height="100%" filter="url(#smoke)" fill="rgba(255,255,255,0.05)" />
            </svg>
            <div className={styles.content}>
                <h1 className={styles.title}>Welcome to Oldkent Shisha Lounge</h1>
                <p className={styles.subtitle}>Experience premium vibes, rich flavours, and unforgettable moments.</p>
                <p className={styles.subtitle}>{subtitle}</p>
                <div className={styles.actions}>
                    <a href="#menu" className={styles.primaryBtn}>Place an order</a>
                </div>
            </div>
        </section>
    );
};

export default Greeting;
